import React, { useEffect } from 'react';
import { Redirect, useParams } from 'react-router-dom';
import { useUserActions } from 'state';
import { Paper } from 'components/_shared/Paper';
import { Spinner } from 'components/_shared/Spinner';
import { FormPage } from 'components/_shared/Page';
import { ROUTES } from '_constants';
import { ConfirmCard } from './components';

export const SingUp = ({ ...props }) => {
  const params = useParams();
  const { isLoading, error, confirmRegistration } = useUserActions();

  useEffect(() => {
    if (params.id) {
      confirmRegistration(params.id);
    }
  }, [params.id, confirmRegistration]);

  if (!params.id) return <Redirect to={ROUTES.AUTH} />;

  if (isLoading) return <Spinner />;

  return (
    <FormPage {...props} header={false}>
      <Paper padding={4}>
        <ConfirmCard error={error} />
      </Paper>
    </FormPage>
  );
};
